import React, { FunctionComponent } from "react";
import { Box, Typography } from "@mui/material";
import styles from "./CardTitle.module.css";
import { format } from "date-fns";

interface CardItemProps {
	title: string;
	date: string;
	link: string;
}

const CardTitle: FunctionComponent<CardItemProps> = ({ title, date, link }) => {
	return (
		<Box className={styles.cardTitle}>
			{isUrl(link) && (
				<a
					href={link}
					className={styles.link}
					target="_blank"
					rel="noopener noreferrer"
				>
					<Box className={styles.linkBox}>
						<Typography variant="caption">{getUrl(link)}</Typography>
					</Box>
				</a>
			)}
			<Typography variant="h3" className={styles.titleText}>
				{title}
			</Typography>
			<Typography variant="caption">
				{date && format(new Date(date), "MMMM dd, yyyy")}
			</Typography>
		</Box>
	);
};

export const isUrl = (urlString: string) => {
	try {
		const url = new URL(urlString);
		return url.protocol === "http:" || url.protocol === "https:";
	} catch (_) {
		return false;
	}
};

const formatUrl = (url) => {
	const max_url = 19;
	if (url.startsWith("www.")) {
		url = url.substring(4);
	}
	if (url.length > max_url) {
		url = "..." + url.substring(url.length - max_url);
	}
	return url;
};

export const getUrl = (url) => {
	return isUrl(url) ? formatUrl(new URL(url).hostname) : "Invalid URL";
};

export default CardTitle;
